/**
 * Attributes that are required on our spritesheet for accessibility reasons.
 * These are the only reason we need a custom `spriteModule` in our
 * svg-sprite-loader config.
 */
export const caSpriteAttributes = {
  /** Prevent the sprite-sheet being read by screen readers. */
  "aria-hidden": "true",
  /** Prevent the sprite-sheet from capturing keyboard focus. */
  focusable: "false",
}
